<template>
  <div>
     <div class="header">
       <div class="header-bar">
         <div class="head-title">刑事审判参考之小包公汇编</div>
         <div class="search-bar">
           <div class="search-bar-body">
            <input type="text" @keydown="keySearch($event)" v-model="searchKey" placeholder="输入关键词或多关键词搜索，中间空格隔开（如：盗窃 抢劫 ）">
            <button class="search-button" @click="searchEvent"><span class="search-icon"><img src="../../assets/search.png" alt=""></span>搜索</button>
           </div>
           
          
         </div>
       </div>
     </div>
     <home></home>
  </div>
</template>

<script>
import Home from '@/views/criminal/home' 
import {sliceStr,highlight} from '../../filter'
export default {
  data () {
    return {
       searchKey:"",
       type: ""
    };
  },

  components: {Home},

  mounted(){
  
  },

  methods: {
    sliceStr:sliceStr,
    highlight:highlight,
    keySearch($event){
      this.resPanelShow = false
      if($event.keyCode == 13){
        this.searchEvent()
      }
    },
    searchEvent(){
      if(this.searchKey){
        this.$router.push({
          path: '/criminal/home',
          query:{
            param: this.searchKey,
            create: true
          }
        })
        let criminalList = JSON.parse(window.sessionStorage.getItem("criminalList"))
        if(criminalList == null){
          criminalList = []
        }
        criminalList && criminalList.push({
          param: this.searchKey,
          name: Date.now() + Math.random().toString(36).substr(2)
        })
        window.sessionStorage.setItem('criminalList',JSON.stringify(criminalList))
      }else{
        this.$message({
          message: "请输入关键词或多关键词搜索，中间空格隔开（如：盗窃 抢劫 ）",
          type: 'error',
          duration: 1000
        })
      }
    }
  }
}

</script>
<style scoped lang="less">
.head-title{
  font-size: 18px;
  color: #fff;
  line-height: 60px;
  padding-left: 12px;
}

.search-bar{
  width: 490px;
  height: 34px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 13px;
  display: flex;
  background: #fff;
  border-radius: 3px;
  z-index: 99;
}

.search-bar input{
  width: 490px;
  height: 100%;
  padding-left: 10px;
  font-size: 14px;
  color: @wordColor1;
  border-radius: 3px;
}

.search-bar-body{
  width: 100%;
  position: relative;
  display: flex;
}


input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
  color:#879BBA;
}
input::-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color:#879BBA;
}

.search-bar .search-button{
  width:80px;
  height: 34px;
  background:rgba(27,156,255,1);
  border-radius:0px 3px 3px 0px;
  text-align: center;
  line-height: 34px;
  border: none;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.search-bar .search-button:hover{
  background: @mainColor;
}

.search-panel{
  position: absolute;
  top: 40px;
  width: 420px;
  height:360px;
  background:rgba(255,255,255,1);
  box-shadow:0px 3px 8px 0px rgba(27,69,137,0.3);
  border-radius:4px;
  border:1px solid @lineColor;
  z-index: 99;
}

.search-panel .hit-item{
  margin: 15px;
}

.hit-item .title{
  color: @wordColor2;
  margin-bottom: 5px;
}

.hit-item p{
  color: @wordColor1;
  line-height: 30px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.search-bar .search-select{
  width: 108px;
}

.search-icon{
  width: 16px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 5px;
  margin-bottom: 4px;
}

.search-icon img{
  display: block;
  width: 100%;
}
</style>
<style lang="less">
.search-bar .el-input__inner{
  height: 34px;
  line-height: 34px;
}
.search-bar .el-input__icon{
  line-height: 34px;
}
</style>


// WEBPACK FOOTER //
// src/views/criminal/Layout.vue